import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class GetHomeDataGqlService {
  readonly document = gql`
    query GetHomeData {
      homeItems(orderBy: order_ASC) {
        name
        title
        text
        order
      }
    }
  `;
}
